import BaseApi from './base'

class Label extends BaseApi {
  getLabels = (query) => this.client.get(`admin/label-interface?${query}`)

  createLabel = (data) => this.client.post('admin/label-interface', data)

  deleteLabel = (id) => this.client.delete(`admin/label-interface/${id}`)

  updateLabels = (languageId, data) =>
    this.client.post(
      `admin/label-interface/translation/bulk-upsert/${languageId}`,
      data
    )

  getSystemLabels = (query) =>
    this.client.get(`admin/system/label-interface?${query}`)

  getPagesByModuleId = (moduleId) =>
    this.client.get(`admin/system/${moduleId}/pages`)

  storeSystemLabelInterface = (data) =>
    this.client.post(`admin/system/cixi-center/store-label-interface`, data, {
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY
      }
    })
}

export default new Label()
